import { Button } from "@cmp-src/primitives/button";
import { ColumnInstance } from "react-table";

export const SortButton = <T extends object>({
  column: { id, toggleSortBy }
}: {
  column: ColumnInstance<T>;
}) => {
  const name = id.split("_")[0];
  return (
    <Button
      onClick={() => toggleSortBy()}
      variant="ghost"
      className="w-full font-normal text-secondary-text"
    >
      <span className="text-muted-foreground capitalize">{name}</span>
    </Button>
  );
};
